import React, { useState, useEffect } from 'react';
import './AmountInput.css';

const AmountInput = ({ value, onChange, name, placeholder, required = false }) => {
  const [displayValue, setDisplayValue] = useState('');

  // Форматирование числа с пробелами для тысяч
  const formatNumber = (num) => {
    if (!num) return '';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  // Удаление всех нецифровых символов
  const cleanNumber = (str) => {
    return str.replace(/\D/g, '');
  };

  // Обработка изменения значения
  const handleChange = (e) => {
    const inputValue = e.target.value;
    const cleanedValue = cleanNumber(inputValue);
    
    // Ограничиваем до 10 цифр (максимум 999,999,999)
    const limitedValue = cleanedValue.slice(0, 10);
    
    // Форматируем для отображения
    const formattedValue = formatNumber(limitedValue);
    
    setDisplayValue(formattedValue);
    
    // Отправляем числовое значение в родительский компонент
    onChange({
      target: {
        name,
        value: limitedValue
      }
    });
  };

  // Обновляем отображаемое значение при изменении пропса value
  useEffect(() => {
    if (value) {
      setDisplayValue(formatNumber(value));
    } else {
      setDisplayValue('');
    }
  }, [value]);

  return (
    <input
      type="text"
      name={name}
      value={displayValue}
      onChange={handleChange}
      className="amount-input"
      placeholder={placeholder}
      required={required}
    />
  );
};

export default AmountInput;
